import { Children, Fragment, isValidElement } from "react";

import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

import type { PropsWithChildren } from "react";

type Props = {
  className?: string;
};

export function NodeFieldsBox({ children, className }: PropsWithChildren<Props>) {
  const rows = Children.toArray(children);

  return (
    <div
      className={twMerge(
        "bg-document-bg shadow-block dark:shadow-block-inverted rounded-6 w-full min-w-0",
        className,
      )}
    >
      {rows.map((row, index) => (
        <Fragment key={isValidElement(row) ? row.key : index}>
          {index > 0 && <Sidebar.Delimiter className="m-0" />}
          {row}
        </Fragment>
      ))}
    </div>
  );
}
